<template>
  <div class="topic item pt-2">
    <div class="top flex flex-col xl:flex-row !h-fit">
      <div class="left">
        <div class="icon"></div>
        <div class="title"><span>Fórum</span></div>
      </div>
      <div class="actions flex flex-row ml-auto mt-2">
        <button :disabled='prev === 0' @click="getTopics(prev)"><i class="fa-solid fa-angle-left"></i></button>
        <button :disabled='total < next' @click="getTopics(next)"><i class="fa-solid fa-angle-right"></i></button>
        <input type="text" name="search" placeholder="Pesquisar" v-model="search" @keydown.enter="getTopics()">
        <button><i class="fa-solid fa-magnifying-glass"></i></button>
      </div>
    </div>
    <div class="content gap-x-4 gap-y-2">
      <template v-if="loading">
        <div class="box shadow-sm border" v-for="i in 8" :key="i">
          <div class="line"></div>
          <Sk w="86px" h="100%" rounded="rounded-l-xl rounded-r-none" />
          <div class="box-data flex flex-col gap-2 justify-center pt-4">
            <Sk w="85%" h="13px" />
            <Sk w="55%" h="10px" />
          </div>
        </div>
      </template>
      <div class="box shadow-sm border" v-else v-for="(t, i) in topics" :key="i">
        <div class="line" :class="{'new': t.new === true}"></div>
        <div v-if="t.fix == 'true'" class="pin-badge" :style="{ backgroundColor: store?.initSite?.color1 || '#21415C' }" title="Fixado">
          <i class="fa-solid fa-thumbtack"></i>
        </div>
        <div class="box-avatar" :style="{backgroundImage: `url('${t?.avatar !== '' ? t.photo : logoAvatar}')`}"></div>
        <div class="box-data">
          <RouterLink :to="{path: `/topico`, name: 'TopicPage', params: {id: t.id, url: t.url}}">
            <div class="title nobr" :title="t.titulo">{{ t.titulo }}</div>
          </RouterLink>
          <div class="flex">
            <div class="user">
              <span><i class="fa-solid fa-user"></i>&nbsp;&nbsp;{{ t.autor }}</span>
              <div class="new" v-if="t.new">NOVO</div>
            </div>
            <div class="comments"><i class="fa-solid fa-message"></i>&nbsp;{{ t.comments }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { getTopics as apiGetTopics } from '@/services/api.js'
import Sk from '@/components/usefulness/Sk.vue'
import { onMounted, ref } from 'vue'
import logoAvatar from '@/assets/logo_avatar.png'
import { useStore } from '@/stores'

const store = useStore()
const topics = ref([])
const loading = ref(true)
const prev = ref(0)
const next = ref(0)
const total = ref(0)
const disableP = ref(true)
const disableN = ref(true)
const search = ref('')

async function getTopics(paga = 1) {
  loading.value = true
  try {
    const data = await apiGetTopics({ pag: paga, s: search.value })
    topics.value = data.topics
    prev.value  = data.prev
    next.value  = data.next
    total.value = data.total
    disableP.value = parseInt(data.prev) === 0
    disableN.value = data.next === 0
  } catch {
    topics.value = []
  } finally {
    loading.value = false
  }
}

onMounted(() => getTopics())

</script>

<style scoped>
.topic .top .icon {
  background-color: #36628A;
  background-position: -30px -64px;
}

.topic .content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.topic .content .box {
  position: relative;
  width: calc(50% - 10px);
  height: 86px;
  background-color: #fff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
}

.topic .content .box .line {
  position: absolute;
  top: 16px;
  left: 0;
  width: 4px;
  height: 54px;
  background-color: var(--color1);
  border-radius: 0 4px 4px 0;
  transition: all .3s ease;
}

.topic .content .box .line.new {
  background-color: #2FC145;
}

.topic .content .box .pin-badge {
  position: absolute;
  top: 4px;
  left: 8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  color: #fff;
  font-size: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
  pointer-events: none;
}

.topic .content .box:hover .line {
  width: 7px;
}

.topic .box .box-avatar {
  width: 86px;
  height: 100%;
  border-radius: 12px 0 0 12px;
  background-color: #F8FAFC;
  background-position: center;
  background-size: cover;
}

.topic .box .box-avatar .avatar {
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.topic .box .box-data {
  width: calc(100% - 90px);
  height: 100%;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.topic .box .box-data .flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.topic .box .box-data .title {
  float: left;
  width: 100%;
  height: 25px;
  line-height: 25px;
  font-size: 15px;
  font-weight: 500;
  color: var(--color1);
  margin-top: 0;
}

.topic .box .box-data .user,
.topic .box .box-data .comments {
  float: left;
  width: 80%;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  margin-top: 0;
  color: #444;
  font-weight: 600;
  user-select: none;
  padding-right: 8px;
}

.topic .box .box-data .comments {
  width: auto;
}

.topic .box .box-data .user span {
  float: left;
}

.topic .box .box-data .new {
  float: left;
  width: auto;
  height: 18px;
  background-color: #2FC145;
  border-radius: 10px;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  padding: 0 6px;
  line-height: 19px;
  margin: 6px 0 0 6px;
}


@media only screen and (max-width: 500px) {

  .topic .content .box {
    width: 100%;
  }
}

</style>
